import React from 'react';
import s from '../DietPlanBuilder.module.css';
import { Icon, Sheet } from '../ui';
import { copy } from '../../copy';
import { fmtG, fmtInt } from '../../lib/format';
import { useFoodSearch } from '../../hooks/useFoodSearch';
import type { Builder, Dispatch } from '../../hooks/useDietPlanBuilder';
import type { Plan } from '../../types';

export function FoodSearchSheet({ plan, state, dispatch, api, onClose }: { plan: Plan; state: Builder['s']; dispatch: Dispatch; api: Builder['api']; onClose: () => void }) {
  const M = plan.meals[state.mi]; const q = state.foodQuery;
  const { list, loading, error } = useFoodSearch(api, q, M.key, true);
  return (
    <Sheet title={copy.search.title} sub={`to ${M.name} option ${state.oi + 1}`} onClose={onClose} onBack={() => dispatch({ type: 'sheet', sheet: 'opt' })}>
      <div style={{ padding: '0 20px 10px', flex: 'none' }}>
        <div className={s.searchBox}><Icon.Search /><input autoFocus value={q} onChange={e => dispatch({ type: 'foodQuery', v: e.target.value })} placeholder={copy.search.placeholder} aria-label={copy.search.placeholder} /></div>
      </div>
      <div className={s.sheetBody} style={{ paddingBottom: 'calc(16px + env(safe-area-inset-bottom))' }}>
        <div className={s.eyebrow}>{q.trim() ? copy.search.db : copy.search.often}</div>
        <div className={`${s.card} ${s.cardTight}`} style={{ borderRadius: 16 }}>
          {loading && !list.length && <div className={s.center}>…</div>}
          {error && <div className={s.center} style={{ color: 'var(--gf-red-ink)' }}>{error.message}</div>}
          {list.map((r, i) => (
            <button type="button" key={`${r.id ?? r.name}-${i}`} className={s.listRow} style={{ padding: '12px 14px' }} onClick={() => dispatch({ type: 'addFood', food: r })}>
              <div className={s.grow}><div className={s.strong} style={{ fontSize: 13.5, fontWeight: 600 }}>{r.name}</div><div className={s.faint} style={{ fontSize: 11.5 }}>{fmtG(r.qty)} {r.unit} · {fmtInt(r.per[0])} kcal · P {fmtG(r.per[1])} C {fmtG(r.per[2])} F {fmtG(r.per[3])}</div></div>
              <span className={s.iconBtn} style={{ width: 30, height: 30, background: 'var(--gf-green-soft)', color: 'var(--gf-green)' }}><Icon.Plus size={15} /></span>
            </button>
          ))}
          {!loading && !error && !list.length && <div className={s.center}>{copy.search.empty(q)}</div>}
        </div>
      </div>
    </Sheet>
  );
}
